angular.module('zc.projects')
  .component('zcInternalUserTable', {
    templateUrl: '/templates/projects.settings/users/internal_user_table.html',
    bindings: {
      project: '<',
    },
    controller: InternalUserTable,
    controllerAs: 'vm'
  });

InternalUserTable.$inject = ['Apollo', 'Devise'];
function InternalUserTable(Apollo, Devise) {
  const vm = this;

  vm.internalUsers = [];
  vm.isCommonUser = Devise.isCommonUser();
  vm.userManagementURL = `${ZC_CONFIG.AIDEAL_URL}/site/${vm.project.apikey}/settings/general/users`;

  function getInternalUsers() {
    const GET_INTERNAL_USERS = gql(`
      query GetInternalUsers($apikey: String, $role: UserRole) {
        project(apikey: $apikey) {
          users(role: $role) {
            full_name
            email
          }
        }
      }`,
    );

    return Apollo.masterQuery(
      GET_INTERNAL_USERS,
      {
        apikey: vm.project.apikey,
        role: 'internal',
      },
    );
  }

  vm.$onInit = () => {
    getInternalUsers()
      .then(res => {
        vm.internalUsers = _.cloneDeep(
          _.get(res, 'project.users', []),
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/users/internal_user_table.js